import {Container} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import PhotogiftOrderLine from "./PhotogiftOrderLine";
import useGoogleFonts from "../../../hooks/useGoogleFonts";
import {templateFontList} from "../../../Components/EditTemplateProduct/common";

const useStyles = makeStyles(theme => ({
    orderPartContainer: {
        backgroundColor: 'white',
        padding: theme.spacing(1),
        position: 'relative',
        marginBottom: disableGutters => (!disableGutters ? 0 : theme.spacing(2))
    },
}));

export default ({
                    items,
                    handleDelete,
                    handleLongPress,
                    handleToggleSelected,
                    selectedItems,
                    selectMode,
                    scrollToItemUuid
                }) => {
    const theme = useTheme();
    const disableGutters = useMediaQuery(theme.breakpoints.down('xs'));
    const classes = useStyles(disableGutters);
    const {loaded: fontsLoaded} = useGoogleFonts(templateFontList);

    return <Box mb={1}>
        <Container disableGutters={disableGutters}>
            <Grid container spacing={disableGutters ? 0 : 2} >
                {items.map((ol, i) => {
                    return <Grid item md={4} sm={6} xs={12} key={ol.uuid}>
                        <PhotogiftOrderLine  key={ol.uuid} orderLine={ol}
                                   className={classes.orderPartContainer}
                                   onDelete={handleDelete} onLongPress={handleLongPress}
                                   onToggleSelected={handleToggleSelected}
                                   selectMode={selectMode} isSelected={selectedItems.indexOf(ol.uuid) >= 0}
                        />
                    </Grid>
                })}
            </Grid>

        </Container>
    </Box>
}